import axios from 'axios';
import Vue from 'vue'



export default {
    get (cartId) {
        return axios.get('/api/cart/get', { params: {cartId: cartId} })
        .then(response => {
            return response;
        })
        .catch(error => {Vue.prototype.$snotify.simple(error);})
    },

    add (cartId, lines) {
        return axios.post('/api/cart/add', { cartId: cartId, lines: lines/*itemVariantId:itemVariantId, quantity:quantity*/})
        .then(response => {
            return response;
        })
        .catch(error => {Vue.prototype.$snotify.simple(error);})
    },

    deliveryModeToCart (cartId, deliveryModeId) {
        return axios.post('/api/cart/set-delivery-mode', { cartId: cartId, deliveryModeId: deliveryModeId})
        .then(response => {
            return response;
        })
        .catch(error => {Vue.prototype.$snotify.simple(error);})
    },

    remove (cartId, itemVariantId) {
        return axios.post('/api/cart/remove', { cartId: cartId, itemVariantId:itemVariantId})
        .then(response => {
            return response;
        })
        .catch(error => {Vue.prototype.$snotify.simple(error);})
    },


    //delivery modes
    getDeliveryModes () {
        return axios.get('/api/cart/delivery-modes')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.simple(error);})
    },

    validationGiftCardCode(setGiftCardToCartRequest){
        return axios.post('/api/cart/set-gift-card' , setGiftCardToCartRequest)
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.simple(error);})
    },
}